import { render, staticRenderFns } from "./EmptySoonWidget.vue?vue&type=template&id=3d87cb5b&scoped=true"
import script from "./EmptySoonWidget.vue?vue&type=script&lang=js"
export * from "./EmptySoonWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d87cb5b",
  null
  
)

export default component.exports